import { BasicSelect, MultiSelect } from "vue-search-select";
import CryptoJS from "crypto-js";
import Pagination from "./../../../../shared/components/pagination";
import CustomExpandableTable from "../../../../shared/components/customExpandableTable";
import Loader from "../../../../shared/components/loader";
import Treeselect from "@riophae/vue-treeselect";
import Utility from "./../../../../utility/services/utility.service";
import FTCMemoDepositSlip from "./../../../../firstAndLastmilemanagement/views/FtcRadShipment/FTCMemoDepositSlip";
import TripServices from "./../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service";
import Printd from "printd";
import VueElementLoading from "vue-element-loading";
import BookingService from "./../../../../cargobooking/services/cargobooking.service";
import Report from './../../../../report/services/report.service';
import adminsettingsService from "../../../../adminsettings/services/adminsettings.service";

export default {
  name: "addextracharges",
  components: {
    VueElementLoading,
  },
  props: ["parentObj", "childcharges"],
  data: function () {
    return {
      accordianTab: { 1: false, 2: false, 3: false },
      expanded: false,
      shippingid: "",
      ShipmentDropByClient: false,
      isLoading: false,
      useremail: "",
      LocationName: "",
      Mobile: "",
      Telephone: "",
      Email: "",
      Address: "",
      GstNo: "",
      TotalShipmentValue: "",
      SelfCollectByClient: false,
      AddNewConsigneeFlag: true,
      ConsigneeEmail: "",
      ConsigneeTelephone: "",
      ATTN: "",
      ConsigneeMobile: "",
      CompanyName: "",
      CSTTINNo: "",
      ConsigneeAddress: "",
      ReferenceNumber: "",
      ClientReferenceNumber: "",
      bookingData: [],
      ChkCollectByClient: "",
      Consigneelist: "",
      selectedConsignee: "",
      ConsigneeCode: "",
      shippingid: "",
      ConsingneeCity: "",
      ConsingneeName: "",
      ConsingneeState: "",
      destinationPincode: "",
      pickupCity: "",
      pickupLocationName: "",
      pickupPincode: "",
      pickupState: "",
	    validate_urp:'',
	    validate_consignee_urp:'',
	    pickupcomments:'',
	    consingneecomments:'',
	    shipmentdetailcomments:'',
	    subtabdisabledflag: true,
	    clientreferencemandatory:false,
      referencemandatory: false,
  	  editBasicDetailsflag:false,
  	  editShipmentValue:false,
  	  editflag:false,
  	  selfcollect:true,
  	  selfdrop:true,
	  clientid : null
    };
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem(
      "cargoAutoaccessuserdata"
    );
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.hubid = userdetail.hubID[0];
  },
  methods: {
    async checkhover() {
      const btn = document.getElementById("btn");
      let tooltip = document.getElementById("tooltip");
      if (tooltip.style.display === "none") {
        tooltip.style.display = "block";
        setTimeout(() => {
          tooltip.style.display = "none";
        }, 2000);
      } else {
        tooltip.style.display = "none";
      }
    },
    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isIntegerOnlty: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  	selectCheckbox(){
  		this.shippingid = this.shippingid.toUpperCase();
  	},
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.search();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async search() {
  	  try {
    		this.isLoading = true;
    		let inputPayload = {};
    		let inputPayload1 = {};
    		if(this.shippingid){
    		  inputPayload1.awb = this.shippingid;
    		  inputPayload.ShippingID = this.shippingid;
    		}else{
    			this.isLoading = false;
    			this.$alertify.error("Shipping Id cannot be blank");
    			return false
    		}
    		let result = await Report.getCargoParentShipmentDetails(inputPayload);
    		if(result.data.data.ReturnCode == 100){
    			let shipmentstatus = result.data.data.ShipmentDetails[0].shipmentstatus.toLowerCase()
    			if(shipmentstatus == 'invalid'){
    				this.isLoading = false;
    				this.clear()
    				this.$alertify.error("Shipment is invalid, cannot update")
    				return false
    			}else if(shipmentstatus == 'pending'){
    				this.selfcollect = false
    				this.selfdrop = false
    			}else if(shipmentstatus == 'delivered'){
    				this.selfdrop = true
    				this.selfcollect = true
    			}else{
    				this.selfdrop = false
    			}
    		}
    		let lrresult = await TripServices.getLRDetails(inputPayload1)
    		this.clear();
    		if (lrresult.data.code == 200) {
    			let clientbusinessaccountid = lrresult.data.data.clientbusinessacountid
    			let clientid = lrresult.data.data.clientid
    			this.clientid = lrresult.data.data.clientid
    			await this.getClientConfiguration(clientid ,clientbusinessaccountid),

    		  this.subtabdisabledflag = false,
    		  this.bookingData = lrresult.data.data;
    		  this.shippingid = this.bookingData.awbnumber
    		  this.GstNo = this.bookingData.pickupgst;
    		  this.LocationName = this.bookingData.pickupname;
    		  this.Mobile = this.bookingData.pickupmobile;
    		  this.Telephone = this.bookingData.pickuptelephone ? this.bookingData.pickuptelephone :null;
    		  this.Email = this.bookingData.pickupemail;
    		  this.Address = this.bookingData.pickupaddress;
    		  this.ShipmentDropByClient = this.bookingData.dropbyclient === 1 ? true : false;
    		  this.TotalShipmentValue = this.bookingData.totalshipmentdeclaredvalue ? this.bookingData.totalshipmentdeclaredvalue:null;
    		  this.SelfCollectByClient = this.bookingData.pickbyclient === 1 ? true : false;
    		  this.ConsigneeAddress = this.bookingData.consingneeaddress;
    		  this.ConsigneeCode = this.bookingData.consingneecode;
    		  this.ConsigneeEmail = this.bookingData.consingneeemail;
    		  this.ConsigneeMobile = this.bookingData.consingneemobile;
    		  this.ConsigneeTelephone = this.bookingData.consingneetelephone;
    		  this.CompanyName = this.bookingData.consingneename;
    		  this.ATTN = this.bookingData.consingneeattn;
    		  this.CSTTINNo = this.bookingData.consingneecsttin;
    		  this.ReferenceNumber = this.bookingData.refnumber?this.bookingData.refnumber:null;
    		  this.ClientReferenceNumber = this.bookingData.clientrefnumber;
    		  this.pickupCity = this.bookingData.pickupcity;
    		  this.pickupState = this.bookingData.pickupstate;
    		  this.ConsingneeCity = this.bookingData.consigneecity;
    		  this.ConsingneeState = this.bookingData.consigneestate;
    		  this.pickupPincode = this.bookingData.pickuppincode;
    		  this.destinationPincode = this.bookingData.destinationpincode;
    		  this.$alertify.success("Record Found. Kindly update the details");
    		}else{
    		  this.isLoading = false;
    		  this.$alertify.error("Something Went Wrong");
    		}
    		this.isLoading = false;
  	  } catch (error) {
    		this.clear();
    		this.isLoading = false;
    		this.$alertify.error("Data Not found");
  	  }
    },
    async clear() {
	    this.shippingid =""
      this.GstNo = "";
      this.LocationName = "";
      this.Mobile = "";
      this.Telephone = "";
      this.Email = "";
      this.Address = "";
      this.ShipmentDropByClient = "";
      this.TotalShipmentValue = "";
      this.ConsigneeAddress = "";
      this.ConsigneeCode = "";
      this.ConsigneeEmail = "";
      this.ConsigneeMobile = "";
      this.ConsigneeTelephone = "";
      this.CompanyName = "";
      this.ATTN = "";
      this.CSTTINNo = "";
      this.ReferenceNumber = "";
      this.ClientReferenceNumber = "";
	  this.pickupcomments = ''
	  this.consingneecomments = ''
	  this.shipmentdetailcomments = ''
	  this.subtabdisabledflag = true
	  this.collapseAll()
    },
	  async getClientConfiguration(clientid,clientbusinessaccid){
		try {
			let input = {
				clientId: clientid,
				clientBusinessAccountId: clientbusinessaccid,
			}
			let result = await adminsettingsService.getClientSettings(input)
			if(result.data.code == 200){
				this.referencemandatory = result.data.data[0].configparam.referenceno == 1 ? true : false
				this.clientreferencemandatory = result.data.data[0].configparam.clientreferenceno == 1 ? true : false
			}
		} catch (error) {
			console.log(err)
		}
	},
    checkPickupLocationValidation() {
      this.$validator
        .validateAll("pickuplocationform")
        .then(async (result) => {
          if (result) {
			try {
				var inputPayload = {};
				inputPayload.awbnumber = this.shippingid;
				inputPayload.clientid = this.clientid;
				inputPayload.lastmodifiedby = this.userName;
				inputPayload.PickupDetails = {
				  IsShipmentDropToHubByClient:
					this.ShipmentDropByClient == true ? 1 : 0,
					PickupComments : this.pickupcomments,
				  Addresses: [
					{
					  Attn: null,
					  Name: this.ShipmentDropByClient == false ? this.LocationName : "",
					  TINNo: this.GstNo,
					  Address: this.ShipmentDropByClient == false ? this.Address : "",
					  EmailID: this.Email,
					},
				  ],
				  ContactDetails: [
					{
					  Type: "Primary",
					  TelNo: this.Telephone,
					  PhoneNo: this.Mobile,
					},
				  ],
				};

				this.isLoading = true;
				let result = await BookingService.updateBookingDetails(inputPayload);
				this.isLoading = false;
				if (result.data.code == 200) {
				  this.$alertify.success("Record Updated Successfully");
				} else {
				  document.activeElement.blur();
				  this.$alertify.error(result.data.message);
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error("Internal Server Error");
			}
          }
        })
        .catch((err) => {
		  this.isLoading = false;
		  this.$alertify.error(err);
          return false;
        });
    },
    checkConsigneeDetailsValidation() {
      this.$validator
        .validateAll("consigneedetailsform")
        .then(async (result) => {
          if (result) {
			try {
				var inputPayload = {};
				inputPayload.awbnumber = this.shippingid;
				inputPayload.clientid = this.clientid;
				inputPayload.lastmodifiedby = this.userName;
				inputPayload.DropDetails = {
				  IsSelfCollectByClient: this.SelfCollectByClient == true ? 1 : 0,
				  ConsigneeComments : this.consingneecomments,
				  Addresses: [
					{
					  Attn: this.ATTN,
					  Name: this.CompanyName,
					  TINNo: this.CSTTINNo,
					  Address: this.SelfCollectByClient == false ? this.ConsigneeAddress : "",
					  EmailID: this.ConsigneeEmail,
					  ConsigneeCode: this.SelfCollectByClient == false ? this.ConsigneeCode : "",
					},
				  ],
				  ContactDetails: [
					{
					  Type: "Consignee",
					  ConsigneeTel: this.ConsigneeTelephone,
					  PhoneNo: this.ConsigneeMobile,
					},
				  ],
				};

				this.isLoading = true;
				let result = await BookingService.updateBookingDetails(inputPayload);
				this.isLoading = false;
				if (result.data.code == 200) {
				  this.$alertify.success("Record Updated Successfully");
				} else {
				  document.activeElement.blur();
				  this.$alertify.error(result.data.message);
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error("Internal Server Error");
			}
          } else {
            return false;
          }
        })
        .catch((err) => {
		  this.isLoading = false;
		  this.$alertify.error(result.data.message);
          console.log("errors exist", err);
          return false;
        });
    },
    checkShipmentTotalValidation() {
      this.$validator
        .validateAll("shipmentdetailsform")
        .then(async (result) => {
          if (result) {
			try {
				var inputPayload = {};
				inputPayload.ShipmentDetails = {
				  DeclaredValue: this.TotalShipmentValue,
				  ReferenceNo: this.ReferenceNumber,
				  ClientReferenceNo: this.ClientReferenceNumber,
				  ShipmentdetailComments : this.shipmentdetailcomments
				};
				inputPayload.awbnumber = this.shippingid;
				inputPayload.lastmodifiedby = this.userName;
				inputPayload.clientid = this.clientid;
				this.isLoading = true;
				let result = await BookingService.updateBookingDetails(inputPayload);
				this.isLoading = false;
				if (result.data.code == 200) {
				  this.$alertify.success("Record Updated Successfully");
				} else {
				  document.activeElement.blur();
				  this.$alertify.error(result.data.message);
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error("Internal Server Error");
			}
          }
        })
        .catch((err) => {
		  this.isLoading = false;
		  this.$alertify.error(result.data.message);
          console.log("errors exist", err);
          return false;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/utility/views/updateBookingDetails/changebasicdetails/updateBookingDetails.component.js